/**
 * Auto-superscript ® (U+00AE) and ™ (U+2122) across the DOM.
 * Runs on load and on dynamically added content.
 */
(function () {
  const TRADEMARK_REGEX = /(®|™)/g;

  function processTextNode(textNode) {
    const text = textNode.textContent;
    if (!TRADEMARK_REGEX.test(text)) return;
    TRADEMARK_REGEX.lastIndex = 0;

    const parent = textNode.parentNode;
    if (!parent || parent.closest('script, style, noscript, sup, menu-drawer, .header__navigation, .header__menu, .page__title')) return;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    TRADEMARK_REGEX.lastIndex = 0;
    while ((match = TRADEMARK_REGEX.exec(text)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(text.slice(lastIndex, match.index))
        );
      }
      fragment.appendChild(document.createTextNode('\u2060'));
      const sup = document.createElement('sup');
      sup.className = 'trademark-sup';
      sup.textContent = match[1];
      fragment.appendChild(sup);
      lastIndex = match.index + match[1].length;
    }
    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    }

    parent.replaceChild(fragment, textNode);
  }

  function processNode(node) {
    const walker = document.createTreeWalker(
      node,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (n) {
          if (!n.textContent || !TRADEMARK_REGEX.test(n.textContent)) {
            return NodeFilter.FILTER_REJECT;
          }
          TRADEMARK_REGEX.lastIndex = 0;
          if (n.parentNode && n.parentNode.closest('script, style, noscript, sup, menu-drawer, .header__navigation, .header__menu, .page__title')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(processTextNode);
  }

  function run() {
    processNode(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            processNode(node);
          }
        });
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
